import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUiStore } from '@/store/uiStore';

export function AppShell() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-surface">
      <Sidebar />
      <div
        className={`transition-all duration-300 ${
          collapsed ? 'ms-16' : 'ms-64'
        }`}
      >
        <Header />
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
